import { useEffect, useState } from "react";
import { useGReverseGeocodeQuery } from "../../api/network/mapApiServices";
import { VehicleStatusCode } from "../../api/types/VehicleStatusCode";
import svgIcons from "../../assets/svg/svgIcons";
import { TLatLng } from "../../types/map";
import { VehicleMapDataPoint } from "../../api/types/VehicleMap";

type TripAddressProps = {
  wrapperClassName?: string;
  assetId: string;
  point: VehicleMapDataPoint;
  pointType: "Start" | "End";
  phone_no: string;
  address: string;
  latlng: TLatLng;
  time: string;
};

const RouteAddress = ({
  wrapperClassName = "relative flex items-start",
  assetId,
  point,
  pointType,
  phone_no,
  address,
  latlng,
  time,
}: TripAddressProps) => {
  const [fullAddress, setFullAddress] = useState<string>(address);

  // before google APIs integration, with bing we were using reverse geocoding
  // to get human-readable addresses, however, with google might not necessarily
  // have reverse geocoding API enabled, thus we can try reverse reocoding or
  // rely completely on data received from database for displaying addresses
  // -------------------------------------------------------------------------
  const { data: dataReverseGeocode, isFetching: isFetchingReverseGeocode } =
    useGReverseGeocodeQuery(latlng, {
      skip: !!address || !latlng.latitude || !latlng.longitude,
    });
  useEffect(() => {
    if (
      !!dataReverseGeocode &&
      !isFetchingReverseGeocode &&
      !!dataReverseGeocode?.results?.[0]?.formatted_address
    ) {
      setFullAddress(dataReverseGeocode?.results?.[0]?.formatted_address);
    }
  }, [dataReverseGeocode, isFetchingReverseGeocode]);

  return (
    <div className={wrapperClassName}>
      {pointType === "Start" && (
        <div className="absolute top-6 left-3 ml-[3px] w-0.5 h-[calc(100%-8px)] border border-dashed border-gray-400" />
      )}
      <img
        src={
          pointType === "Start"
            ? point.statuscode === VehicleStatusCode.STATUS_IGNITION_ON
              ? svgIcons.StartLocation
              : svgIcons.UnknownTripLocation
            : point.statuscode === VehicleStatusCode.STATUS_IGNITION_OFF
              ? svgIcons.EndLocation
              : svgIcons.UnknownTripLocation
        }
        alt="location-icon"
        className="p-2"
      />
      <div className="font-medium space-y-1">
        <div className="text-[12px] leading-4 text-heading-gray444 pe-12">
          <div className="text-accent-blue-dark">{assetId}</div>
          {!!phone_no && (
            <p className={!!phone_no ? "" : "text-gray-400/80"}>
              {phone_no || "(000) 000-0000"}
            </p>
          )}
          {!!fullAddress && <p>{fullAddress}</p>}
        </div>
        <p className="text-[10px] leading-3 text-heading-gray888">{time}</p>
      </div>
    </div>
  );
};
export default RouteAddress;
